import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { CYAN, GREY, inr } from "@/lib/format";

export function NumberField({ label, value, onChange, min = 0, max = 100, step = 1, prefix, suffix, testid }) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="font-mono text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
        <div className="flex items-center gap-1 border border-border bg-background px-2 py-1">
          {prefix && <span className="font-mono text-xs text-muted-foreground">{prefix}</span>}
          <Input
            type="number" value={value} data-testid={testid}
            onChange={(e) => onChange(Number(e.target.value))}
            className="tool-input h-6 w-28 border-0 bg-transparent p-0 text-right font-mono text-sm text-foreground focus-visible:ring-0"
          />
          {suffix && <span className="font-mono text-xs text-muted-foreground">{suffix}</span>}
        </div>
      </div>
      <Slider value={[value]} min={min} max={max} step={step} onValueChange={(v) => onChange(v[0])} data-testid={`${testid}-slider`} />
    </div>
  );
}

export function Stat({ label, value, highlight, testid }) {
  return (
    <div className="border border-border bg-background p-5" data-testid={testid}>
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{label}</p>
      <p className={`mt-2 font-mono text-2xl font-bold ${highlight ? "text-cyan" : "text-foreground"}`}>{value}</p>
    </div>
  );
}

export function Donut({ data }) {
  return (
    <div className="h-52 w-full" data-testid="donut-chart">
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data} dataKey="value" innerRadius={60} outerRadius={85} stroke="none" paddingAngle={2}>
            {data.map((_, i) => <Cell key={i} fill={i === 0 ? CYAN : GREY} />)}
          </Pie>
          <Tooltip
            contentStyle={{ background: "#ffffff", border: "1px solid #d4d0c8", borderRadius: 0, fontFamily: "JetBrains Mono", fontSize: 12, color: "#141414" }}
            formatter={(v, n) => [inr(v), n]}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export function ToolShell({ title, desc, children }) {
  return (
    <div data-testid="tool-shell">
      <h3 className="font-display text-2xl font-extrabold uppercase text-foreground md:text-3xl">{title}</h3>
      <p className="mb-8 mt-2 max-w-2xl text-sm text-muted-foreground">{desc}</p>
      {children}
    </div>
  );
}
